import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { PartnerService } from '../../../../services/partner.service';
import { WhatsappForBusinessService } from '../../../../services/whatsapp-for-business.service';
import { AppConfig } from '../../../../app.config';

import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-message-types',
  templateUrl: './message-types.component.html',
  styleUrls: ['./message-types.component.scss'],
  providers: [MessageService],
})
export class MessageTypesComponent implements OnInit {
  public partnerId: string = '';
  public partner: any = {};
  public messageTemplates: any = [];
  public messageTemplatesFull: any = [];
  public messageTemplate: any = {};
  public originalMessageTemplate: any = {};
  public selectedMessageTemplate: any = {};
  public loading : boolean = false;
  public saving: boolean = false;
  public classicTemplate = false;
  public showMessageType = false;
  public isWorkshop = true;
  public isRentals = false;
  public whatsappConfiguredEnabled: boolean = false;
  userSearchTerm = '';
  searchTerm = '';
  isExpanded = false;  

  constructor(
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    public messageService: MessageService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    public appConfig: AppConfig,
    public whatsappForBusinessService : WhatsappForBusinessService
  ) {
    this.partnerId = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();
  }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/store/rentals/message-templates'
    ) {
      this.isRentals = true;
      this.isWorkshop = false;
    }
    this.loading = true;

    this.getWhatsAppConfig();
    this.getMessageTemplates();
  }

  closePanel() {
    this.showMessageType = false;
  }

  getWhatsAppConfig(){
    this.whatsappForBusinessService.getWhatsAppConfiguration(this.helpersService.getPartnerId()).subscribe(res=>{
      if(res.storeConfig && res.storeConfig.id){
        this.whatsappConfiguredEnabled = true;
      }
    });
  }

  async getMessageTemplates() {
    //this.messageTemplates = [];    
    this.partnerService
      .getMessageTemplatesV2(this.partnerId)
      .subscribe((templates) => {
        templates.forEach((template) => {
          var order =
            this.appConfig.getMessageTemplateOrder()[template.EventTag];
          if (order) {
            template.Order = order;
          } else {
            template.Order = 100;
          }
        });

        this.messageTemplates = templates.map((item) => {
          return { label: item.EventTag.toUpperCase(), value: item.ID };
        });
        this.messageTemplatesFull = templates;
        this.loading = false;
      }, err=>{
        this.loading = false;
      });
  }

  getBikeFittingsTemplates() {
    return this.messageTemplatesFull
      .filter((item) => {
        return this.translate
          .instant(item.EventTag)
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      })
      .filter((x) => {
        return x.Description.toLowerCase() === 'fitting';
      })
      .sort((a, b) => {
        if (a.Order < b.Order) {
          return -1;
        } else if (a.Order > b.Order) {
          return 1;
        } else {
          return 0;
        }
      });
  }

  getShopRidesTemplates() {
    return this.messageTemplatesFull
      .filter((item) => {
        return this.translate
          .instant(item.EventTag)
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      })
      .filter((x) => {
        return x.Description.toLowerCase() === 'shop ride';
      })
      .sort((a, b) => {
        if (a.Order < b.Order) {
          return -1;
        } else if (a.Order > b.Order) {
          return 1;
        } else {
          return 0;
        }
      });
  }

  getServiceTemplates() {
    return this.messageTemplatesFull
      .filter((item) => {
        return this.translate
          .instant(item.EventTag)
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      })
      .filter((item) => {
        return this.translate
          .instant(item.EventTag)
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      })
      .filter((x) => {
        return x.Description.toLowerCase() === 'service';
      })
      .sort((a, b) => {
        if (a.Order < b.Order) {
          return -1;
        } else if (a.Order > b.Order) {
          return 1;
        } else {
          return 0;
        }
      });
  }

  getBikeSaleTemplates() {
    return this.messageTemplatesFull
      .filter((item) => {
        return this.translate
          .instant(item.EventTag)
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      })
      .filter((x) => {
        return x.Description.toLowerCase() === 'bike sale';
      })
      .sort((a, b) => {
        if (a.Order < b.Order) {
          return -1;
        } else if (a.Order > b.Order) {
          return 1;
        } else {
          return 0;
        }
      });
  }

  getCouponTemplates() {
    return this.messageTemplatesFull
      .filter((item) => {
        return this.translate
          .instant(item.EventTag)
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      })
      .filter((x) => {
        return x.Description.toLowerCase() === 'coupon';
      })
      .sort((a, b) => {
        if (a.Order < b.Order) {
          return -1;
        } else if (a.Order > b.Order) {
          return 1;
        } else {
          return 0;
        }
      });
  }

  getGiftCardTemplates() {
    return this.messageTemplatesFull
      .filter((item) => {
        return this.translate
          .instant(item.EventTag)
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      })
      .filter((x) => {
        return x.Description.toLowerCase() === 'gift cards';
      })
      .sort((a, b) => {
        if (a.Order < b.Order) {
          return -1;
        } else if (a.Order > b.Order) {
          return 1;
        } else {
          return 0;
        }
      });
  }

  getRentalTemplates() {
    return this.messageTemplatesFull
      .filter((item) => {
        return this.translate
          .instant(item.EventTag)
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      })
      .filter((x) => {
        return x.Description.toLowerCase() === 'rentals';
      })
      .sort((a, b) => {
        if (a.Order < b.Order) {
          return -1;
        } else if (a.Order > b.Order) {
          return 1;
        } else {
          return 0;
        }
      });
  }

  handleSidePanel(element: any) {
    this.showMessageType = false;
    element.destroyModal();
  }

  selectMessageType(item) {
    this.selectedMessageTemplate = item;
    this.showMessageType = true;
  }

  searchSettings() {
    if (this.userSearchTerm.length > 0) {
      this.searchTerm = this.userSearchTerm.replace(' ', '.');
      this.getBikeFittingsTemplates();
      this.getServiceTemplates();
      this.getBikeSaleTemplates();
      this.getCouponTemplates();
      this.getGiftCardTemplates();
      this.getRentalTemplates();
      this.isExpanded = true;
    } else {
      this.searchTerm = '';
      this.userSearchTerm = '';
      this.isExpanded = false;
    }

    // if (this.searchTerm.length > 0) {
    //   this.messaging = this.filterArray(this.messaging, this.searchTerm);
    //   this.productsAndServices = this.filterArray(
    //     this.productsAndServices,
    //     this.searchTerm,
    //   );
    //   this.general = this.filterArray(this.general, this.searchTerm);
    //   this.plugins = this.filterArray(this.plugins, this.searchTerm);
    //   this.services = this.filterArray(this.services, this.searchTerm);
    //   this.payments = this.filterArray(this.payments, this.searchTerm);
    //   this.workflow = this.filterArray(this.workflow, this.searchTerm);
    // } else {
    //   this.resetFilters();
    // }
  }
}
